import isEmpty from "lodash/isEmpty"
import isNil from "lodash/isNil"

export const isEmptyValue = (
  value: string | number | boolean | null | undefined,
): boolean => isNil(value) || (typeof value === "string" && isEmpty(value))
